import { withErrorBoundary } from "@sentry/nextjs";
import clsx from "clsx";
import { FC } from "react";
import { twMerge } from "tailwind-merge";
import { Pricing5Content } from "types/graphql/generated";

type Pricing5CardHeaderContent = Pick<
  Pricing5Content["pricing5Cards"][number]["pricing5Title"],
  "monthlyPrice" | "participantFee" | "discountedMonthlyPrice"
> & { discountedMonthlyPriceColor: string };

interface Props {
  content: Pricing5CardHeaderContent;
}

const Pricing5CardPrice: FC<Props> = withErrorBoundary(
  ({ content: { monthlyPrice, discountedMonthlyPrice, participantFee, discountedMonthlyPriceColor = "" } }) => {
    const basePriceClasses = "text-neutral-900 lg:text-5xl font-semibold leading-normal text-4xl";

    const pricingClasses = clsx({
      "relative text-fog-80 opacity-40": discountedMonthlyPrice,
    });

    return (
      <>
        <div className="flex items-end">
          <div className={twMerge(basePriceClasses, pricingClasses)}>
            {monthlyPrice}
            {discountedMonthlyPrice && (
              <div className={"absolute left-0 right-0 top-[55%] border-t-[2.5px] border-fog-80"} />
            )}
          </div>
          {discountedMonthlyPrice && (
            <div
              className={twMerge(basePriceClasses, "pl-2")}
              style={{
                color: discountedMonthlyPriceColor,
              }}
            >
              {discountedMonthlyPrice}
            </div>
          )}
          <div
            className="ml-[2px] text-nowrap text-base font-bold tracking-normal lg:text-lg"
            style={{
              color: discountedMonthlyPrice ? discountedMonthlyPriceColor : "",
            }}
          >
            / month
          </div>
        </div>
        <div className="mt-1 text-base font-semibold leading-[22px] tracking-normal lg:text-lg lg:leading-[26px] lg:tracking-[-0.004em]">
          {participantFee}
        </div>
      </>
    );
  },
  {}
);

export { Pricing5CardPrice };
